import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { capitalizeFirstLetter } from "../../utils/Helper";

function Filter({
  appliedFilters,
  show,
  onHide,
  onApplyFilter,
  onClear,
}) {
  const [filters, setFilters] = useState({
    agenda : appliedFilters?.agenda || "",
    relationship_manager_id: appliedFilters?.relationship_manager_id || "",
    channel_partner_id: appliedFilters?.channel_partner_id || "",
    product_id: appliedFilters?.product_id || "",
    region_id: appliedFilters?.region_id || "",
    state_id: appliedFilters?.state_id || "",
    city_id: appliedFilters?.city_id || "",
    from_date: appliedFilters?.from_date || "",
    to_date: appliedFilters?.to_date || "",
    member_id: appliedFilters?.member_id || "",

  });
  const [filterOptions, setFilterOptions] = useState({
    regions: [],
    cities: [],
    states: [],
    rm: [],
    channelPtNames: [],
    productList: [],
  });
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const navigate = useNavigate();

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const [regions, channelPtNames, productList,memberList] =
        await Promise.all([
          APIServices.get(`/admin/cms/region_list/${"101"}`, headers),
          APIServices.get("/admin/channel_partner/short_list", headers),
          APIServices.get("/admin/product/list?offset=0&limit=100", headers),
          APIServices.get("/admin/member/short_list", headers),
        ]);

    
      setFilterOptions({
        regions: regions?.data?.list || [],
        channelPtNames: channelPtNames?.data?.list || [],
        productList: productList?.data?.list || [],
        memberList: memberList?.data?.list || [],
      });
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };


  const fetchStates = async (regionId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/state_list/${regionId}`,
        headers
      );
      if (response?.status === 200) {
        const stateList = response?.data?.list || [];
        setFilterOptions((pre) => ({ ...pre, states: stateList }));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setFilterOptions((pre) => ({ ...pre, states: [] }));
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/city_list/${stateId}`,
        headers
      );
      if (response?.status === 200) {
        const citiesList = response?.data?.list || [];
        setFilterOptions((pre) => ({ ...pre, cities: citiesList }));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setFilterOptions((pre) => ({ ...pre, cities: [] }));
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const fetchRm = async (chPartnerId) => {
    try {
      const response = await APIServices.get(
        `/admin/relationship_manager/by_channel_partner/${chPartnerId}`,
        headers
      );
      if (response?.status === 200) {
        const rmList = response?.data?.list || [];
        setFilterOptions((pre) => ({ ...pre, rm: rmList }));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setFilterOptions((pre) => ({ ...pre, rm: [] }));
      }
    } catch (error) {
      console.error("Error fetching rm:", error);
    }
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });

    if (name === "region_id") {
      setFilters((pre) => ({ ...pre, state_id: "", city_id: "" }));
      fetchStates(value);
    }
    if (name === "state_id") {
      setFilters((pre) => ({ ...pre, city_id: "" }));
      fetchCities(value);
    }
    if (name === "channel_partner_id") {
      setFilters((pre) => ({ ...pre, relationship_manager_id: "" }));
      fetchRm(value);
    }
  };

  return (
    <Offcanvas
      className="mom_filter"
      show={show}
      onHide={onHide}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="font_blue_18 font-600">
          Filter By
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0">
        <Form className="filter_form">
          <div>
            <label className="font_blue_14 font-500 mb-2">
              Channel Partner
            </label>
            <Form.Select
              name="channel_partner_id"
              value={filters.channel_partner_id}
              onChange={handleFilterChange}
            >
              <option value="">Select Channel Partner</option>
              {filterOptions?.channelPtNames?.map((chPtType) => (
                <option key={chPtType.id} value={chPtType.id}>
                  {capitalizeFirstLetter(chPtType.name)}
                </option>
              ))}
            </Form.Select>
          </div>


          <div>
            <label className="font_blue_14 font-500 mb-2">
              Relationship Manager
            </label>
            <Form.Select
              name="relationship_manager_id"
              value={filters.relationship_manager_id}
              onChange={handleFilterChange}
            >
              <option value="">Select Relationship Manager</option>
              {filterOptions?.rm?.map((rm) => (
                <option key={rm.id} value={rm.id}>
                  {capitalizeFirstLetter(`${rm.first_name} ${rm.last_name}`)}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">Product Name</label>
            <Form.Select
              name="product_id"
              value={filters.product_id}
              onChange={handleFilterChange}
            >
              <option value="">Select Product Name</option>
              {filterOptions?.productList?.map((product) => (
                <option key={product.id} value={product.id}>
                  {capitalizeFirstLetter(product.name)}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">Member</label>
            <Form.Select
              name="member_id"
              value={filters.member_id}
              onChange={handleFilterChange}
            >
              <option value="">Select Member</option>
              {filterOptions?.memberList?.map((memeber) => (
                <option key={memeber.id} value={memeber.id}>
                  {capitalizeFirstLetter(memeber.fullname)}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">Region</label>
            <Form.Select
              name="region_id"
              value={filters.region_id}
              onChange={handleFilterChange}
            >
              <option value="">Select Region</option>
              {filterOptions?.regions?.map((region) => (
                <option key={region.id} value={region.id}>
                  {capitalizeFirstLetter(region.name)}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">State</label>
            <Form.Select
              name="state_id"
              value={filters.state_id}
              onChange={handleFilterChange}
            >
              <option value="">Select State</option>
              {filterOptions?.states?.map((state) => (
                <option key={state.id} value={state.id}>
                  {capitalizeFirstLetter(state.name)}
                </option>
              ))}
            </Form.Select>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">City</label>
            <Form.Select
              name="city_id"
              value={filters.city_id}
              onChange={handleFilterChange}
            >
              <option value="">Select City</option>
              {filterOptions?.cities?.map((city) => (
                <option key={city.id} value={city.id}>
                  {capitalizeFirstLetter(city.name)}
                </option>
              ))}
            </Form.Select>
          </div>
        </Form>
        <div className="offcanvas-footer">
          <button className="btn blue_border" onClick={onClear}>
            Clear
          </button>
          <button
            className="btn red_button"
            onClick={() => onApplyFilter(filters)}
          >
            Apply
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Filter;
